import React from 'react';
import { motion } from 'framer-motion';
import { Reveal } from '../components/Reveal';
import useScrambleText from '../hooks/useScrambleText';
import { useData } from '../components/DataContext';

const About = () => {
  const { aboutContent } = useData();
  const h2Ref = useScrambleText(aboutContent.title);
  const h3Ref = useScrambleText(aboutContent.heading);

  return (
    <section id="about" className="py-24 bg-background relative overflow-hidden">
      {/* Decorative Background Elements */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-primary/5 to-transparent pointer-events-none" />
      
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image Side */}
          <Reveal>
            <div className="relative group">
              <div className="absolute inset-0 bg-primary/20 translate-x-4 translate-y-4 group-hover:translate-x-2 group-hover:translate-y-2 transition-transform duration-500" />
              <div className="relative overflow-hidden aspect-[3/4] border border-white/10 group-hover:border-primary/50 transition-colors duration-500">
                <img 
                  src={aboutContent.mainImage} 
                  alt="Korov DJ" 
                  className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-transparent opacity-80" />
              </div>
            </div>
          </Reveal>

          {/* Text Side */}
          <Reveal delay={0.2}>
            <h2 ref={h2Ref} className="text-primary font-heading text-sm tracking-[0.3em] uppercase mb-4 cursor-pointer">{aboutContent.title}</h2>
            <h3 ref={h3Ref} className="text-4xl md:text-5xl font-heading font-bold korov-gradient-text mb-8 leading-tight cursor-pointer">
              {aboutContent.heading}
            </h3>
            
            <div className="space-y-6 text-muted-foreground text-lg leading-relaxed font-body">
              <p>{aboutContent.paragraph1}</p>
              <p>{aboutContent.paragraph2}</p>
            </div>

            <div className="mt-10 grid grid-cols-2 gap-8">
              <div className="group cursor-default">
                <h4 className="text-2xl font-heading text-gradient-platinum mb-2 group-hover:text-primary transition-colors">{aboutContent.stat1Value}</h4>
                <p className="text-sm text-muted-foreground uppercase tracking-wider">{aboutContent.stat1Label}</p>
              </div>
              <div className="group cursor-default">
                <h4 className="text-2xl font-heading text-gradient-platinum mb-2 group-hover:text-primary transition-colors">{aboutContent.stat2Value}</h4>
                <p className="text-sm text-muted-foreground uppercase tracking-wider">{aboutContent.stat2Label}</p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default About;
